<template>
  <AppAlert v-show="product != 'thailand_5_years'" class="mt-6">
    <span v-html="$tt('thailand_page.exempt_alert')" />
  </AppAlert>
  <AppDialog v-model="listVisible">
    <v-card class="pt-2">
      <CloseBtn size="small" class="close" @click="listVisible = false" />
      <v-card-title>{{ $tt('thailand_page.exempt_modal_title') }}</v-card-title>
      <v-card-text>
        <ul>
          <li v-for="nationality in NATIONALITIES">
            {{ tCountry(nationality) }}
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </AppDialog>
</template>

<script setup lang="ts">
import type { CountryIso, ProductName } from '~/types';

const NATIONALITIES: CountryIso[] = [
  "ALB", "AND", "AUS", "AUT", "BHR", "BEL", "BTN", "BRA", "BRN", "BGR", "KHM", "CAN", "CHN", "COL", "HRV", "CUB", "CYP", "CZE", "DNK", "DMA", "DOM", "ECU", "EST", "FJI", "FIN", "FRA", "GEO", "DEU", "GRC", "GTM", "HKG", "HUN", "ISL", "IND", "IDN", "IRL", "ISR", "ITA", "JAM", "JPN", "JOR", "KAZ", "KOR", "XKX", "KWT", "LAO", "LVA", "LIE", "LTU", "LUX", "MAC", "MYS", "MDV", "MLT", "MUS", "MEX", "MCO", "MNG", "MAR", "NLD", "NZL", "NOR", "OMN", "PAN", "PNG", "PER", "PHL", "POL", "PRT", "QAT", "ROU", "RUS", "SMR", "SAU", "SGP", "SVK", "SVN", "ESP", "LKA", "ZAF", "SWE", "CHE", "TWN", "TON", "TTO", "TUR", "UKR", "ARE", "GBR", "USA", "URY", "UZB", "VNM"
];

defineProps<{
  product: ProductName;
}>();

const { tCountry } = useLocalization();

const listVisible = ref(false);
useListener('click', 'exempt-list-opener', () => {
  listVisible.value = true;
});
</script>

<style scoped>
.close {
  position: absolute;
  top: 0;
  right: 0;
}
</style>